<template>
    <component :is="template">
        <v-container>
            <v-row>
                <v-col>
                    <div class="contents-area">
                        <div class="contents-area__inner">
                            <div class="tit-wrap tit-wrap--unberline">
                                <v-row align="center">
                                    <v-col cols="12" md="">
                                        <v-row align="center" class="row--small">
                                            <v-col cols="auto">
                                                <v-btn icon text small @click="()=>$router.push('/dshop/products')"><v-icon>mdi-arrow-left</v-icon></v-btn>
                                            </v-col>
                                            <v-col>
                                                <h2 class="tit">배송상품 검색</h2>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                    <v-col cols="12" md="auto">
                                        <v-text-field v-model="searchValue" name="search" type="search" autocomplete="off" hide-details outlined placeholder="배송상품 검색" class="w-100 w-md-260px" @keydown.enter="setQuery()">
                                            <template v-slot:append>
                                                <v-icon v-show="searchValue" size="28" class="mr-1" @click="searchValue = null">mdi-close</v-icon>
                                                <v-icon size="28" @click="setQuery()">mdi-magnify</v-icon>
                                            </template>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </div>
                            <delivery-list/>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </component>
</template>

<script>
import api from '@/api'
import DeliveryList from '@/components/client/dshop/delivery-list.vue';

export default {
    components: { DeliveryList },
    data() {
        return {
            me: null,
            meLoaded: true,

            products: [],

            page: Number(this.$route.query.page) || 1,
            limit: 28,
            pageCount: 0,

            dialog: false,
            searchValue: this.$route.query?.searchValue || null
        };
    },
    mounted() {
        this.init();
    },
    created(){
        if(this.logoff) this.$router.push(`/login`);
    },
    methods: {
        async init() {
            let { me } = await  api.v1.me.profile.get();
            this.me = me;
            this.meLoaded = true;
        },
        setQuery() {
            let { ...query } = this.$route.query;
            query.searchKey = "name";
            query.searchValue = this.searchValue;

            if (!query?.sort) delete query.sort;
            if (!query?._category) delete query._category;
            if (!query?.searchValue) {
                delete query.searchValue
                delete query.searchKey
            }

            query.page = 1;
            this.$router.push({ query });
        },
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.gshop}`);
        },
        accessToken(){
            return this.$store.state.accessToken;
        },
        logoff(){
            return !this.$store.state.accessToken;
        },
    },
};
</script>

<style lang="scss" scoped>
@media (min-width: 1024px) {
    .contents-area {
        padding: 60px 114px;
    }
}
</style>
